module.exports = __webpack_public_path__ + "img/livecamera_capetown.44aa8f6c.png";